module.exports = __webpack_public_path__ + "gy.f51fccfc1c5fb75fc0c5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gy.svg
// module chunks = styles